import React, { useMemo, useState } from "react";

/**
 * Floating bid button shown when at least one group has an active bidding window.
 *
 * Props:
 * - activeBids: [{ groupId, groupName, periodNumber, endsAt, isOrganiserBenefit }]
 * - onOpenBid: (groupId) => void
 */
export default function FloatingBidButton({ activeBids = [], onOpenBid }) {
  const [openList, setOpenList] = useState(false);

  const primary = useMemo(() => (Array.isArray(activeBids) ? activeBids[0] : null), [activeBids]);
  if (!primary) return null;

  const hasMultiple = Array.isArray(activeBids) && activeBids.length > 1;

  return (
    <div className="floatingBidWrap">
      {openList && hasMultiple && (
        <div className="floatingBidList" role="dialog" aria-label="Active bidding">
          <div className="floatingBidListTitle">Active bidding</div>
          {activeBids.map((b) => (
            <button
              key={`${b.groupId}-${b.periodNumber ?? ""}`}
              className="floatingBidListItem"
              onClick={() => {
                setOpenList(false);
                onOpenBid?.(b.groupId);
              }}
              type="button"
            >
              <div className="floatingBidGroup">{b.groupName || `Group ${b.groupId}`}</div>
              <div className="floatingBidMeta">
                Period {b.periodNumber ?? "?"}{b.isOrganiserBenefit ? " • Organiser benefit" : ""}
              </div>
            </button>
          ))}
        </div>
      )}

      <button
        className="floatingBidBtn"
        onClick={() => {
          if (hasMultiple) setOpenList((v) => !v);
          else onOpenBid?.(primary.groupId);
        }}
        aria-label="Open bidding"
        title="Open bidding"
        type="button"
      >
        🔨
        <span className="floatingBidDot" aria-hidden="true" />
      </button>
    </div>
  );
}
